export const locale = {
    lang: "es-ES",
    data: {
        DIALOG: {
            CONFIRM: "OK",
            CANCEL: "CANCELAR",
            DESC: "Ingrese la siguiente oración para confirmar: ",
            CONFIRMATION: "eliminar permanentemente",
            KNOW_MORE: "MÁS INFORMACIÓN",
            NO: "NO",
            YES: "SI"
        }
    }
};
